import {
  successAction,
  GET_DIRECTIONS,
  GET_EVENT_TYPES,
  GET_RESPONSIBLE,
  GET_GAMES,
  GET_PLATFORMS,
  GET_VERSIONS,
  GET_CHANNELS,
  GET_TECH_TAGS,
  GET_TYPE_TAGS,
  GET_CLASS_TAGS,
  GET_EXTRA_FIELDS_LIST,
} from '../types';

const initialState = {
  directions: [],
  eventTypes: [],
  responsible: [],
  game: [],
  platform: [],
  versions: [],
  channels: [],
  classTags: [],
  techTags: [],
  typeTags: [],
  extraFieldsList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case successAction(GET_DIRECTIONS): {
      return {
        ...state,
        directions: action.payload,
      };
    }
    case successAction(GET_EVENT_TYPES): {
      return {
        ...state,
        eventTypes: action.payload,
      };
    }
    case successAction(GET_RESPONSIBLE): {
      return {
        ...state,
        responsible: action.payload,
      };
    }
    case successAction(GET_GAMES): {
      return {
        ...state,
        game: action.payload,
      };
    }
    case successAction(GET_PLATFORMS): {
      return {
        ...state,
        platform: action.payload,
      };
    }
    case successAction(GET_VERSIONS): {
      return {
        ...state,
        versions: action.payload,
      };
    }
    case successAction(GET_CHANNELS): {
      return {
        ...state,
        channels: action.payload,
      };
    }
    case successAction(GET_TECH_TAGS): {
      return {
        ...state,
        techTags: action.payload,
      };
    }
    case successAction(GET_TYPE_TAGS): {
      return {
        ...state,
        typeTags: action.payload,
      };
    }
    case successAction(GET_CLASS_TAGS): {
      return {
        ...state,
        classTags: action.payload,
      };
    }
    case successAction(GET_EXTRA_FIELDS_LIST): {
      return {
        ...state,
        extraFieldsList: action.payload,
      };
    }
    default:
      return state;
  }
};
